import type { IMetrics } from '../metrics/types';
import type { ILogger } from '../logging/types';

/** PerformanceObserver + Long Tasks. Degrada se API ausente. */
export function installPerformanceObservers(
  metrics: IMetrics,
  logger: ILogger,
): () => void {
  if (typeof PerformanceObserver === 'undefined') {
    return () => undefined;
  }

  const observers: PerformanceObserver[] = [];

  const observe = (type: string, handler: (entries: PerformanceEntryList) => void) => {
    try {
      const observer = new PerformanceObserver((list) => handler(list.getEntries()));
      observer.observe({ type, buffered: true });
      observers.push(observer);
    } catch {
      logger.debug('PerformanceObserver unsupported', { type });
    }
  };

  observe('longtask', (entries) => {
    for (const entry of entries) {
      metrics.increment('perf.longtask');
      logger.debug('Long task', { durationMs: entry.duration, name: entry.name });
    }
  });

  observe('navigation', (entries) => {
    for (const entry of entries) {
      const nav = entry as PerformanceNavigationTiming;
      metrics.gauge('perf.navigation.duration', nav.duration);
      logger.debug('Navigation timing', {
        durationMs: nav.duration,
        domContentLoaded: nav.domContentLoadedEventEnd,
      });
    }
  });

  return () => {
    for (const observer of observers) {
      observer.disconnect();
    }
  };
}
